module.exports = __webpack_public_path__ + "img/背景框.98896946.png";